import React from 'react'

function TenderTextNTK() {
  return (
    <embed src="\pdfs\EAT1.3.4_DB-N_NTK-floor_twist_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextNTK